import { ODSButton } from 'kfone-component-library';
import { ButtonIconPosition } from 'kfone-component-library/enums';
import { PlusIcon } from 'kfone-component-library/svgIcons';
import { kf1I18nString } from 'kfone-frontend-core';
import { useNavigate } from 'react-router-dom';
import { useFileStore } from 'store';
import useCountryStore from 'store/CountryStore';
import useNewReportStore from 'store/NewReport';
import { twMerge } from 'tailwind-merge';
import './index.css';

const ReportCardComponent = () => {
  const navigate = useNavigate();
  const { resetCountryStore } = useCountryStore();
  const { resetReportStore } = useNewReportStore();
  const { resetSelectedCategory } = useFileStore();

  const handleStartNewReport = () => {
    resetCountryStore();
    resetReportStore();
    resetSelectedCategory();

    navigate('/payequity/generate-report');
  };
  return (
    <>
      <p className='report-header'>{kf1I18nString('pe.landingPage.welcome')}</p>
      <p className='text-ods-font-styles-body-regular-small'>
        {kf1I18nString('pe.landingPage.welcomeToPayEquityReportingDesc')}
      </p>
      <div className='report-container'>
        <div className='report-container-item'>
          <div>
            <p className='text-ods-font-styles-heading-xxsmall'>
              {kf1I18nString('pe.landingPage.startNewReport')}
            </p>
            <p className='pt-ods-spacing-gap-small text-ods-font-styles-body-regular-small'>
              {kf1I18nString('pe.landingPage.startNewReportDesc')}
            </p>
          </div>
          <div>
            <ODSButton
              className={twMerge('report-container-item-button')}
              id='start-new-report-btn'
              text={kf1I18nString('pe.startNewReport')}
              icon={<PlusIcon />}
              iconPosition={ButtonIconPosition.Left}
              onClick={handleStartNewReport}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ReportCardComponent;
